<ng-container [formGroup]="formGroupCampaignTypeData">
    <div class="d-flex align-items-center mat-slide-toggle__wrapper">
        <app-mdb-switch label="Send receipt QR code" formControlName="sendTickets" id="sendTickets"></app-mdb-switch>
      <div class="d-flex align-items-center ml-2 h-100">
        <app-text-popover
          placement="right"
          type="content"
          text="Switch ON if you want to send an email with a receipt QR code along with the payment confirmation. This is useful if you would like to mark the item(s) as delivered or picked up."
          title=""
        >
        </app-text-popover>
      </div>
    </div>
    <div class="divider"></div>

    <div>
      <div class="d-flex align-items-center mat-slide-toggle__wrapper">
        <app-mdb-switch label="Enforce item inventory for this campaign" formControlName="enforceCampaignInventory"></app-mdb-switch>
        <div class="d-flex align-items-center ml-2 h-100">
          <app-text-popover
            placement="right"
            type="content"
            text="To control the number of items sold across all options in this campaign, switch this ON. For eg., if you are selling red, white and black t-shirts but you are only able to sell 200 t-shirts overall, you would switch this ON and enter 200 as the inventory count."
            title=""
          >
          </app-text-popover>
        </div>
      </div>
      <div style="padding-left: 44px;" class="mb-4" *ngIf="formGroupCampaignTypeData.value.enforceCampaignInventory">
        <mdb-form-control class="form-fill mb-0" >
          <app-mdbp-input mdbInput formControlName="campaignInventory" [isCurrencyMask]="true"  label='Item inventory count'>
              <input  #inputNameC currencyMask formControlName="campaignInventory" [options]="{ allowNegative: false, prefix: '', inputMode: 1 }"   class="form-control form-control--paybee"/>
              <mdb-error class="form-fill-error ml-0" style="margin-top: 2px;" *ngIf="formGroupCampaignTypeData.controls.campaignInventory.hasError('min') && formGroupCampaignTypeData.controls.campaignInventory.touched">Please provide Global Total Inventory bigger than 0</mdb-error>
              <mdb-error class="form-fill-error ml-0" style="margin-top: 2px;" *ngIf="formGroupCampaignTypeData.controls.campaignInventory.hasError('incorrect') && formGroupCampaignTypeData.controls.campaignInventory.touched">Please provide Global Total Inventory bigger than Sold</mdb-error>
          </app-mdbp-input>
        </mdb-form-control>
        <div class="d-flex group-ticket-info__container px-2 py-1" style="width: fit-content;font-size: 12px; padding-left: 14px!important;"[ngStyle]="{'margin-top': isTolalInventoryValid?'10px':'20px'}">
          <div class="group-ticket-info__icon mr-2 d-flex align-items-center">
              <img src="img/svg/quickpay/group-ticket.svg" height="15" width="15">
          </div>
          <div class="group-ticket-info__content" style="font-weight: 400;">
              {{getSold()}}
          </div>
        </div>

        <div class="d-flex align-items-center">
          <app-mdb-switch label="Hide item inventory for this campaign" formControlName="hideCampaignInventory"></app-mdb-switch>
          <div class="ml-2 h-100">
              <app-text-popover
                  placement="right"
                  type="content"
                  text="To control the number of items sold in this campaign but hide the number of remaining items left, switch this ON."
                  title=""
              >
              </app-text-popover>
          </div>
      </div>
      </div>
    </div>

  <div class="divider"></div>

  <div class="d-flex align-items-center mat-slide-toggle__wrapper">
    <app-mdb-switch label="Enable Grid View On Donor Side" formControlName="gridView" id="gridView"></app-mdb-switch>
    <div class="d-flex align-items-center ml-2 h-100">
      @if(formGroupCampaignTypeData.controls.gridView.value){
        <i class="fas fa-th mr-2"></i>
      }@else{
        <i class="fas fa-bars mr-2"></i>
      }
      <app-text-popover
        placement="right"
        type="content"
        text="The item options are displayed as a list on the donor side by default. To enable grid view, switch ON."
        title=""
       >
    </app-text-popover>
    </div>
  </div>
  <div class="divider"></div>
</ng-container>